import { APIDownError, CartUrl } from "../directives/utilities/urls";
export default function activityCartConfirmation() {
    return {
        cardDetails: [],
        cartConfirmationDetails: [],
        adddressPhoneDetails: [],
        payments: [],
        terms: [],
        showErrorMesage: "",
        message: "Loading information please wait...",
        lineItems: [],
        showLoader: false,
        total_Amount: 0,
        isSubmitting: false,
        currentFormattedDate: '',
        confirmationMessage: '',
        paymentReceiptNumber: '',
        referenceNumber: '',
        entryDate: '',
        addressDetails: '',
        localAddress: '',
        permanentAddress: '',
        phoneDetails: '',
        addedCoursesList: [],
        waitListCoursesList: [],
        scheduledCoursesList:[],
        people: '',
        isSucess:false,
     
        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
             
            );
            return formattedDate;
        },
        bindCartList() {
           
            this.showLoader = true;
         
            fetch("/api/Checkout/fee-summary?isFromSession=true", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;

                    if (response != undefined && response.isSuccess) {
                        if (response.lineItems.length > 0) {
                            this.total_Amount = response.lineItems.reduce((sum, item) => sum += item.fee, 0);
                            Array.prototype.push.apply(this.lineItems, response.lineItems);
                        } else {
                            this.showErrorMesage = "your cart is empty.";
                        }
                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },
        bindProfile() {
            
            this.addressDetails = JSON.parse(sessionStorage.getItem('addressDetails')  );
            this.phoneDetails = JSON.parse(sessionStorage.getItem('phoneDetails'));
        },
        bindConfirmationList() {
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/Checkout/Confirmation", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {

                    return response.json();
                })
                .then((response) => {                                  
                    if (response != undefined && response.isSuccess) {
                        this.cartConfirmationDetails = response;
                        
                        this.scheduledCoursesList = response.scheduledCourses;
                        this.waitlistCartList = response.waitlistCourses;
                        Array.prototype.push.apply(this.payments, response.payments);
                        Array.prototype.push.apply(this.terms, response.terms);

                        if (response.payments.length > 0) {
                            this.entryDate = new Date(response.payments[0].entryDate).toLocaleString();
                            this.paymentReceiptNumber = response.payments[0].receiptNumber;
                            this.referenceNumber = response.peopleCodeId;
                            this.confirmationMessage = "Credit Card Sale " + new Date(response.payments[0].entryDate).toLocaleString() + " Card Type " + response.payments[0].cardInfo.split(' ')[0] + " Entry Method Keyed Card " + response.payments[0].cardInfo.split(' ')[1] + " Invoice " + this.paymentReceiptNumber + " Clerk 1 Approved " + response.payments[0].chargeCreditCode + " Amount USD $" + response.payments[0].amount + " I Agree to Pay Above Total Amount According to Card Issuer Agreement or Merchant Agreement if Credit Voucher ________________________ Signature: " + response.payments[0].cardName
                        } else {
                            this.entryDate = this.currentFormattedDate;
                            this.referenceNumber = "N/A"
                            this.paymentReceiptNumber = "N/A";
                        }
                    
                      
                    } else {
                        this.message = response.messages.length > 0 ? response.messages.join(', ') : response.message;
                    }
                    this.showLoader = false;
                    this.isSucess = response.isSuccess;
                });
        },
      
        init() {
            this.currentFormattedDate = new Date().toLocaleDateString();
            this.bindProfile();
            this.bindCartList();
            this.bindConfirmationList();

        },
    };
}
